import React from 'react';
import { useSelector } from 'react-redux';
import DateGranularityDropdown from '../../components/UI/DateGranularityDropdown';
import { useGetImpactOverTimeQuery, useGetDriverSplitQuery, useGetImpactOverviewTableQuery } from '../../redux/api/compassProject';
import PlotContainer from '../PlotContainer';
import TableContainer from '../TableContainer';
import '../containerStyles.css';

function FullChannelImpjactNCac() {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const selectedDateGranularity = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedDrivers = useSelector((state) => state.compass.drivers);

    return (
        <div>
            <div className='full-width-container' style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                <div style={{
                    width: '25%',
                    height: '100%',
                }}>
                    <PlotContainer useApi={useGetDriverSplitQuery} useApiArgs={{
                        client_name: selectedClient,
                        start_date: selectedStartDate,
                        end_date: selectedEndDate,
                        granularity: selectedDateGranularity,
                        drivers: selectedDrivers
                    }} />
                </div>
                <hr></hr>
                <div style={{
                    width: '75%',
                    height: '100%',
                }}>
                    <PlotContainer useApi={useGetImpactOverTimeQuery} useApiArgs={{
                        client_name: selectedClient,
                        start_date: selectedStartDate,
                        end_date: selectedEndDate,
                        granularity: selectedDateGranularity,
                        drivers: selectedDrivers
                    }} />
                </div>
            </div>
            <TableContainer useApi={useGetImpactOverviewTableQuery} apiParams={{
                client_name: selectedClient,
                start_date: selectedStartDate,
                end_date: selectedEndDate,
                granularity: selectedDateGranularity,
                drivers: selectedDrivers
            }} />
        </div>
    );
}

export default FullChannelImpjactNCac;